function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import classname from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import FormGroup from "./FormGroup";
import Input from "./Input";
import Label from "./Label";
var count = 0;

function getID() {
  return "form-choice-".concat(count++); // eslint-disable-line no-plusplus
}

var FormChoice = /*#__PURE__*/function (_React$Component) {
  _inherits(FormChoice, _React$Component);

  var _super = _createSuper(FormChoice);

  function FormChoice(props) {
    var _this;

    _classCallCheck(this, FormChoice);

    _this = _super.call(this, props);
    _this.id = props.id || getID();
    return _this;
  }

  _createClass(FormChoice, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          inline = _this$props.inline,
          disabled = _this$props.disabled,
          children = _this$props.children,
          containerClassName = _this$props.containerClassName,
          type = _this$props.type,
          value = _this$props.value,
          attributes = _objectWithoutProperties(_this$props, ["id", "inline", "disabled", "children", "containerClassName", "type", "value"]);

      if (type === 'select') {
        return /*#__PURE__*/React.createElement("option", _extends({}, attributes, {
          disabled: disabled,
          value: value
        }), children);
      }

      var containerClasses = classname({
        'form-check-inline': inline
      }, containerClassName);
      var computedValue = value || children;
      var item = /*#__PURE__*/React.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/React.createElement(Input, _extends({
        id: this.id,
        type: type
      }, attributes, {
        disabled: disabled,
        value: computedValue,
        style: {
          cursor: disabled && 'not-allowed'
        }
      })), /*#__PURE__*/React.createElement(Label, {
        className: "form-check-label",
        check: !inline,
        for: this.id,
        style: {
          cursor: disabled && 'not-allowed'
        }
      }, children));

      if (inline) {
        return item;
      }

      return /*#__PURE__*/React.createElement(FormGroup, {
        check: true,
        disabled: disabled
      }, item);
    }
  }]);

  return FormChoice;
}(React.Component);

FormChoice.propTypes = {
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio', 'select']),
  value: PropTypes.any
};
FormChoice.displayName = "FormChoice";
export default FormChoice;